import type {CaseReducer, PayloadAction} from '@reduxjs/toolkit'
import {shallowEqual} from 'react-redux'

import type {PipelineDraftState} from './EditPipelinePage.slices.types'
import {getJob} from './EditPipelinePage.slices.utils'

export const setFilesPublication: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    jobId: string
    files: undefined | string[]
  }>
> = (state, action) => {
  const {id, jobId, files} = action.payload
  const job = getJob(state, id, jobId)

  if (job != null && !shallowEqual(job['files-publication'], files)) {
    job['files-publication'] = files
  }
}

export const deleteFilesPublication: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    jobId: string
  }>
> = (state, action) => {
  const {id, jobId} = action.payload
  const job = getJob(state, id, jobId)

  if (job != null) {
    delete job['files-publication']
  }
}
